import Image from 'next/image'

const AvatarCell = ({ imgUrl, name }: { imgUrl: string; name: string }) => {
  return (
    <div className="flex items-center">
      {/* circle should clip contents */}
      <div className="w-[30px] h-[30px] rounded-full">
        <Image
          src={imgUrl}
          alt="avatar"
          width={30}
          height={30}
          className="w-full h-auto"
          // @@TODO: Because image is smaller than 40x40 px, it is advised not to use a placeholder image.
          //placeholder="blur"
          //blurDataURL="/head-659650_1280.png"
        />
      </div>
      <div className="flex mx-2 text-sm font-medium">{name}</div>
    </div>
  )
}

export default AvatarCell
